<template>
  <div class="history">
    <span v-if="!isApproveMode && !isHistoryMode && !isDeployMode" class="headerSelect">
      <select v-model="envSelect.value" @change="handleChange">
        <option v-for="option in options" :value="option.value" :key="option.value">{{ option.name }}</option>
      </select>
    </span>
    <div v-if="hasReviewPermission">
      <span v-if="!isApproveMode" class="history-btn" @click="switchApproveMode">審核</span>
      <span v-else class="history-btn" @click="switchApproveMode">回首頁</span>
    </div>
    <div v-if="hasApprovePermission">
      <span v-if="!isDeployMode" class="history-btn" @click="switchDeployMode">上版</span>
      <span v-else class="history-btn" @click="switchDeployMode">回首頁</span>
    </div>
    <span v-if="isHistoryMode" class="history-btn" @click="switchMode">回首頁</span>
    <span v-else class="history-btn" @click="switchMode">記錄查詢</span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { hasSpecifiedPermission, permission } from '@/utils/permission-type';


export default {
  name: 'Header',
  data: () => ({
      envSelect: {
        name: 'dev', value: 'DEV'
      },
      options: [
      {
        name: 'dev', value: 'DEV',
      },
      {
        name: 'prod', value: 'PROD',
      }
      ]
  }),
  computed: {
    ...mapGetters(['isHistoryMode','isDeployMode', 'isApproveMode', 'user']),
    hasReviewPermission() {
      return hasSpecifiedPermission(permission.REVIEW, this.user?.permissions ?? [])
    },
    hasApprovePermission() {
      return hasSpecifiedPermission(permission.APPROVE, this.user?.permissions ?? [])
    }
  },
  methods: {
    switchMode() {
      this.$store.commit('setKeyword', '')
      this.$store.commit('setHistoryMode', !this.isHistoryMode)
      if (!this.isHistoryMode) {
        this.$store.dispatch('getData')
      }
    },
    switchDeployMode() {
      this.$store.commit('setKeyword', '')
      this.$store.commit('setDeployMode', !this.isDeployMode)
      if (!this.isDeployMode) {
        this.$store.dispatch('getData')
      }
    },
    switchApproveMode() {
      this.$store.commit('setKeyword', '')
      this.$store.commit('setApproveMode', !this.isApproveMode)
      if (!this.isApproveMode) {
        this.$store.dispatch('getData')
      }
    },
    handleChange(){
      this.$store.commit('setEnv', this.envSelect.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.history {
  display: inline-block;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .history-btn {
    padding-right: 1rem;
    color: white;
    text-decoration: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
}

.headerSelect {
  position: absolute;
  left: 10px;
  padding: 0 10px;
  flex: 1;
}
</style>